import getBranch from '../../branch/lib/getBranch.lib.branch';
import getBranchTowingServices from '../../branch/lib/getBranchTowingServices.lib.branch';

const WEEKDAY_ORDER = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

const formatName = (value) => {
  const text = (value || '').trim();
  if (!text) return '';
  return text[0].toUpperCase() + text.slice(1).toLowerCase();
};

const getInitial = (value) => {
  const text = formatName(value);
  return text ? text[0] : '';
};

const formatHour = (hour) => {
  const value = Number(hour);
  if (!Number.isFinite(value)) return '';
  if (value === 0) return '12 AM';
  if (value === 12) return '12 PM';
  return value > 12 ? `${value - 12} PM` : `${value} AM`;
};

const formatOfficeHours = (branch) => {
  const rules = branch?.operationstimerule?.rules || {};
  return WEEKDAY_ORDER.map((day) => {
    const openHours = rules[day]?.open || [];
    if (!openHours.length) return null;
    return `${day.toUpperCase()} ${formatHour(openHours[0])} - ${formatHour(
      (openHours[openHours.length - 1] + 1) % 24
    )}`;
  })
    .filter(Boolean)
    .join('\n');
};

const formatTowing = (branch) =>
  getBranchTowingServices(branch)
    .map((service) => {
      const name = (service?.name || '').trim();
      const phone = (service?.phone_number || '').trim();
      if (name && phone) return `${name} (${phone})`;
      return name || phone || '';
    })
    .filter(Boolean)
    .join(', ');

const formatAddress = (...parts) =>
  parts
    .map((part) => (part || '').trim())
    .filter(Boolean)
    .join(', ');

const resolveBranch = ({driver, ticket} = {}) =>
  getBranch(ticket?.sally_branch || driver?.sally_branch) ||
  ticket?.sally_branch ||
  driver?.sally_branch ||
  null;

const buildShortcutTemplateValues = ({driver, ticket, user} = {}) => {
  const firstName = formatName(user?.first_name);
  const lastName = formatName(user?.last_name);
  const driverFirstName = formatName(driver?.first_name);
  const driverLastName = formatName(driver?.last_name);
  const driverName = [driverFirstName, driverLastName].filter(Boolean).join(' ');
  const branch = resolveBranch({driver, ticket});

  return {
    first_name: firstName,
    last_name: lastName,
    first_initial: getInitial(firstName),
    last_initial: getInitial(lastName),
    driver_name: driverName,
    branch: (branch?.name || '').trim(),
    towing: formatTowing(branch),
    office_hours: formatOfficeHours(branch),
    office_addr: formatAddress(
      branch?.street_address1,
      branch?.street_address2,
      branch?.zipcode
    ),
    garage_addr: formatAddress(
      branch?.garage_address1,
      branch?.garage_address2,
      branch?.garage_zipcode
    ),
  };
};

const renderShortcutMessage = (message, context = {}) => {
  if (!message) return '';

  const values = buildShortcutTemplateValues(context);

  return message.replace(/\{\{\s*([\w]+)\s*\}\}/g, (match, key) =>
    Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match
  );
};

export default renderShortcutMessage;
